import currencies, { suggestedCurrencies } from "@i18n/currencies";

type Option = {
  label: string;
  value: string;
};

export const currencySelectOptions: (isMulti?: boolean) => Option[] = isMulti => {
  const notSuggestedKeys = Object.keys(currencies).filter(key => !suggestedCurrencies.includes(key));
  return suggestedCurrencies.concat(notSuggestedKeys).map(key => ({
    color: isMulti ? "#6ab7d0" : undefined,
    label: currencies[key],
    value: key
  }));
};
